import React from 'react';
import { INFO } from 'constants/version';

const Version = () => {
    return <div>{JSON.stringify(INFO)}</div>;
};

export { Version as VersionUnwrapped };
export default Version;
